import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LimitsSummarySuperuserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LimitsSummarySuperuserQuery = { __typename?: 'Query', limitsSummary: { __typename?: 'LimitsSummary', validity: { __typename?: 'LimitsValidity', issuedFor: string, hostname?: Array<string> | null, expirationDate?: string | null }, features: { __typename?: 'LimitsFeatures', callQueue: boolean, billing: boolean, sipUris: boolean }, capabilitySets: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string, systemLimit?: number | null }>, deviceTypeSets: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string, systemLimit?: number | null }>, services: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string, systemLimit?: number | null }>, packages: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string, systemLimit?: number | null }> } };

export type LimitsSummaryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LimitsSummaryQuery = { __typename?: 'Query', limitsSummary: { __typename?: 'LimitsSummary', validity: { __typename?: 'LimitsValidity', issuedFor: string, hostname?: Array<string> | null, expirationDate?: string | null }, features: { __typename?: 'LimitsFeatures', callQueue: boolean, billing: boolean, sipUris: boolean }, capabilitySets: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string }>, deviceTypeSets: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string }>, services: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string }>, packages: Array<{ __typename?: 'LimitsQuota', allocated: number, used: number, name: string }> } };


export const LimitsSummarySuperuserDocument = gql`
    query LimitsSummarySuperuser {
  limitsSummary {
    validity {
      issuedFor
      hostname
      expirationDate
    }
    features {
      callQueue
      billing
      sipUris
    }
    capabilitySets {
      allocated
      used
      name
      systemLimit
    }
    deviceTypeSets {
      allocated
      used
      name
      systemLimit
    }
    services {
      allocated
      used
      name
      systemLimit
    }
    packages {
      allocated
      used
      name
      systemLimit
    }
  }
}
    `;

/**
 * __useLimitsSummarySuperuserQuery__
 *
 * To run a query within a React component, call `useLimitsSummarySuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimitsSummarySuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimitsSummarySuperuserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLimitsSummarySuperuserQuery(baseOptions?: Apollo.QueryHookOptions<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>(LimitsSummarySuperuserDocument, options);
      }
export function useLimitsSummarySuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>(LimitsSummarySuperuserDocument, options);
        }
export function useLimitsSummarySuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>(LimitsSummarySuperuserDocument, options);
        }
export type LimitsSummarySuperuserQueryHookResult = ReturnType<typeof useLimitsSummarySuperuserQuery>;
export type LimitsSummarySuperuserLazyQueryHookResult = ReturnType<typeof useLimitsSummarySuperuserLazyQuery>;
export type LimitsSummarySuperuserSuspenseQueryHookResult = ReturnType<typeof useLimitsSummarySuperuserSuspenseQuery>;
export type LimitsSummarySuperuserQueryResult = Apollo.QueryResult<LimitsSummarySuperuserQuery, LimitsSummarySuperuserQueryVariables>;
export const LimitsSummaryDocument = gql`
    query LimitsSummary {
  limitsSummary {
    validity {
      issuedFor
      hostname
      expirationDate
    }
    features {
      callQueue
      billing
      sipUris
    }
    capabilitySets {
      allocated
      used
      name
    }
    deviceTypeSets {
      allocated
      used
      name
    }
    services {
      allocated
      used
      name
    }
    packages {
      allocated
      used
      name
    }
  }
}
    `;

/**
 * __useLimitsSummaryQuery__
 *
 * To run a query within a React component, call `useLimitsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimitsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimitsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLimitsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<LimitsSummaryQuery, LimitsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimitsSummaryQuery, LimitsSummaryQueryVariables>(LimitsSummaryDocument, options);
      }
export function useLimitsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimitsSummaryQuery, LimitsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimitsSummaryQuery, LimitsSummaryQueryVariables>(LimitsSummaryDocument, options);
        }
export function useLimitsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LimitsSummaryQuery, LimitsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LimitsSummaryQuery, LimitsSummaryQueryVariables>(LimitsSummaryDocument, options);
        }
export type LimitsSummaryQueryHookResult = ReturnType<typeof useLimitsSummaryQuery>;
export type LimitsSummaryLazyQueryHookResult = ReturnType<typeof useLimitsSummaryLazyQuery>;
export type LimitsSummarySuspenseQueryHookResult = ReturnType<typeof useLimitsSummarySuspenseQuery>;
export type LimitsSummaryQueryResult = Apollo.QueryResult<LimitsSummaryQuery, LimitsSummaryQueryVariables>;